import { UseFormReturn } from 'react-hook-form'

import { TokenWithBalance } from '@/domain/common/types'
import { Token } from '@/domain/types/Token'
import { Objective } from '@/features/actions/logic/types'
import { DialogActionsPanel } from '@/features/dialogs/common/components/DialogActionsPanel'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { DialogForm } from '../components/DialogForm'
import { PageStatus } from '@/features/dialogs/common/types'

import { RepayOverviewPanel } from '../components/RepayOverviewPanel'
import { PositionOverview } from '../logic/types'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { FormFieldsForDialog, RepayFormSchema } from '../logic/form'

export interface RepayViewProps {
  debtAsset: Token
  repayOptions: TokenWithBalance[]
  assetsToRepayFields: FormFieldsForDialog
  form: UseFormReturn<RepayFormSchema>
  objectives: Objective[]
  pageStatus: PageStatus
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
  currentLiquidationPrice?: NormalizedUnitNumber
  updatedLiquidationPrice?: NormalizedUnitNumber
  setActionsInProgress: (actionsInProgress: boolean) => void
}

export function RepayView({
  debtAsset,
  repayOptions,
  assetsToRepayFields,
  form,
  objectives,
  pageStatus,
  currentPositionOverview,
  updatedPositionOverview,
  currentLiquidationPrice,
  updatedLiquidationPrice,
  setActionsInProgress,
}: RepayViewProps) {
  return (
    <MultiPanelDialog>
      <FormAndOverviewWrapper>
        <DialogForm form={form} assetsFields={assetsToRepayFields} selectorAssets={repayOptions} />
        <RepayOverviewPanel
          debtAsset={debtAsset}
          collateralAsset={undefined}
          currentPositionOverview={currentPositionOverview}
          updatedPositionOverview={updatedPositionOverview}
          currentLiquidationPrice={currentLiquidationPrice}
          updatedLiquidationPrice={updatedLiquidationPrice}
        />
      </FormAndOverviewWrapper>

      <DialogActionsPanel
        objectives={objectives}
        onFinish={pageStatus.goToSuccessScreen}
        enabled={pageStatus.actionsEnabled}
        setActionsInProgress={setActionsInProgress}
      />
    </MultiPanelDialog>
  )
}
